// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"267":"3df28132","291":"cd61c18d","329":"4fb0468b","348":"3328c3b8","396":"f1495b17","480":"432fa7a2","700":"49e023c2","970":"8970e343"}[chunkId] + ".css";
};